"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useUpdatePassword = void 0;
var keys_1 = require("../keys");
var useMutation_1 = require("../useMutation");
var react_1 = require("react");
var useUpdatePassword = function (_a) {
    var _b = _a === void 0 ? {} : _a, successAction = _b.successAction;
    var _c = (0, useMutation_1.useMutation)({
        path: keys_1.UPDATE_PASSWORD,
        successAction: successAction,
    }), data = _c.data, mutate = _c.mutate, isSubmitting = _c.isSubmitting, error = _c.error;
    return (0, react_1.useMemo)(function () { return ({
        updatePassword: mutate,
        isSubmitting: isSubmitting,
        error: error,
        data: data,
    }); }, [mutate, isSubmitting, error]);
};
exports.useUpdatePassword = useUpdatePassword;
